module.exports = __webpack_public_path__ + "static/flags/XK-c2d33fd88cf4740dac648b3c4d2ef120.gif";